module.exports = __webpack_public_path__ + "assets_app/img/key-6.cfd7d22f.svg";